__turbopack_context__.v({
  "circularContainer": "CircularShowcase-module__ooiBDq__circularContainer",
  "content": "CircularShowcase-module__ooiBDq__content",
  "imgContainer": "CircularShowcase-module__ooiBDq__imgContainer",
  "lowerBlock": "CircularShowcase-module__ooiBDq__lowerBlock",
  "root": "CircularShowcase-module__ooiBDq__root",
  "sticky": "CircularShowcase-module__ooiBDq__sticky",
  "text": "CircularShowcase-module__ooiBDq__text",
  "upperBlock": "CircularShowcase-module__ooiBDq__upperBlock",
});
